export const brandAssets = {
  logoColor: require('@/assets/brand/6ambkk-horizontal-color.png'),
  logoReverse: require('@/assets/brand/6ambkk-horizontal-reverse.png'),
  stackedColor: require('@/assets/brand/6ambkk-stacked-color.png'),
} as const;

export const mediaAssets = {
  homeViewBg: require('@/assets/media/6am-home-view-bg-540p-30fps-n8.mp4'),
} as const;
